import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../../config';

function Stylists() {
  const [stylists, setStylists] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showAvailabilityModal, setShowAvailabilityModal] = useState(false);
  const [editingStylist, setEditingStylist] = useState(null);
  const [selectedStylist, setSelectedStylist] = useState(null);
  const [availability, setAvailability] = useState([]);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    bio: '',
    is_active: 1
  });
  const [image, setImage] = useState(null);
  const [availabilityForm, setAvailabilityForm] = useState({
    day_of_week: 1,
    start_time: '09:00',
    end_time: '17:00',
    is_available: 1
  });

  const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  useEffect(() => {
    fetchStylists();
  }, []);

  const fetchStylists = async () => {
    try {
      const response = await axios.get(`${API_URL}/stylists/admin`);
      setStylists(response.data);
    } catch (error) {
      console.error('Error fetching stylists:', error);
    }
  };

  const fetchAvailability = async (stylistId) => {
    try {
      const response = await axios.get(`${API_URL}/stylists/${stylistId}/availability`);
      setAvailability(response.data);
    } catch (error) {
      console.error('Error fetching availability:', error);
    }
  };

  const openModal = (stylist = null) => {
    if (stylist) {
      setEditingStylist(stylist);
      setFormData({
        name: stylist.name,
        email: stylist.email || '',
        phone: stylist.phone || '',
        bio: stylist.bio || '',
        is_active: stylist.is_active
      });
    } else {
      setEditingStylist(null);
      setFormData({
        name: '',
        email: '',
        phone: '',
        bio: '',
        is_active: 1
      });
    }
    setImage(null);
    setShowModal(true);
  };

  const openAvailabilityModal = async (stylist) => {
    setSelectedStylist(stylist);
    await fetchAvailability(stylist.id);
    setShowAvailabilityModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append('name', formData.name);
    data.append('email', formData.email);
    data.append('phone', formData.phone);
    data.append('bio', formData.bio);
    data.append('is_active', formData.is_active);
    if (image) {
      data.append('image', image);
    }

    try {
      if (editingStylist) {
        await axios.put(`${API_URL}/stylists/${editingStylist.id}`, data);
      } else {
        await axios.post(`${API_URL}/stylists`, data);
      }
      fetchStylists();
      setShowModal(false);
    } catch (error) {
      console.error('Error saving stylist:', error);
      alert('Error saving stylist: ' + (error.response?.data?.error || error.message));
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to deactivate this stylist?')) {
      await axios.delete(`${API_URL}/stylists/${id}`);
      fetchStylists();
    }
  };

  const handleAddAvailability = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API_URL}/stylists/${selectedStylist.id}/availability`, availabilityForm);
      await fetchAvailability(selectedStylist.id);
      setAvailabilityForm({
        day_of_week: 1,
        start_time: '09:00',
        end_time: '17:00',
        is_available: 1
      });
    } catch (error) {
      console.error('Error adding availability:', error);
      alert('Error adding availability: ' + (error.response?.data?.error || error.message));
    }
  };

  const handleDeleteAvailability = async (id) => {
    if (window.confirm('Are you sure you want to delete this availability slot?')) {
      try {
        await axios.delete(`${API_URL}/stylists/${selectedStylist.id}/availability/${id}`);
        await fetchAvailability(selectedStylist.id);
      } catch (error) {
        console.error('Error deleting availability:', error);
      }
    }
  };

  return (
    <div className="stylists">
      <div className="header">
        <h2>Stylists</h2>
        <button onClick={() => openModal()} className="btn">Add Stylist</button>
      </div>

      <div className="stylists-grid">
        {stylists.map(stylist => (
          <div key={stylist.id} className={`stylist-card ${stylist.is_active ? '' : 'inactive'}`}>
            {stylist.image_url && (
              <img src={stylist.image_url} alt={stylist.name} className="stylist-image" />
            )}
            <div className="stylist-info">
              <h3>{stylist.name} {!stylist.is_active && <span className="inactive-badge">Inactive</span>}</h3>
              {stylist.email && <p><strong>Email:</strong> {stylist.email}</p>}
              {stylist.phone && <p><strong>Phone:</strong> {stylist.phone}</p>}
              {stylist.bio && <p className="bio">{stylist.bio}</p>}
              <div className="stylist-actions">
                <button onClick={() => openAvailabilityModal(stylist)} className="btn-small">Availability</button>
                <button onClick={() => openModal(stylist)} className="btn-small">Edit</button>
                <button onClick={() => handleDelete(stylist.id)} className="btn-small warning">Deactivate</button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {showModal && (
        <div className="modal">
          <div className="modal-content stylist-modal">
            <div className="modal-header">
              <h3>{editingStylist ? 'Edit Stylist' : 'Add Stylist'}</h3>
              <button className="modal-close" onClick={() => setShowModal(false)}>×</button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Name *</label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) => setFormData({...formData, name: e.target.value})}
                  required
                />
              </div>
              <div className="form-group">
                <label>Email</label>
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({...formData, email: e.target.value})}
                />
              </div>
              <div className="form-group">
                <label>Phone</label>
                <input
                  type="tel"
                  value={formData.phone}
                  onChange={(e) => setFormData({...formData, phone: e.target.value})}
                />
              </div>
              <div className="form-group">
                <label>Bio</label>
                <textarea
                  value={formData.bio}
                  onChange={(e) => setFormData({...formData, bio: e.target.value})}
                  rows="3"
                />
              </div>
              <div className="form-group">
                <label>Profile Image</label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => setImage(e.target.files[0])}
                />
              </div>
              <div className="form-group">
                <label>
                  <input
                    type="checkbox"
                    checked={formData.is_active === 1}
                    onChange={(e) => setFormData({...formData, is_active: e.target.checked ? 1 : 0})}
                  />
                  Active
                </label>
              </div>
              <div className="modal-actions">
                <button type="submit" className="btn-primary">
                  {editingStylist ? 'Update Stylist' : 'Add Stylist'}
                </button>
                <button type="button" className="btn-secondary" onClick={() => setShowModal(false)}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {showAvailabilityModal && selectedStylist && (
        <div className="modal">
          <div className="modal-content availability-modal">
            <div className="modal-header">
              <h3>Availability for {selectedStylist.name}</h3>
              <button className="modal-close" onClick={() => setShowAvailabilityModal(false)}>×</button>
            </div>

            <form onSubmit={handleAddAvailability} className="availability-form">
              <div className="form-row">
                <div className="form-group">
                  <label>Day of Week</label>
                  <select
                    value={availabilityForm.day_of_week}
                    onChange={(e) => setAvailabilityForm({...availabilityForm, day_of_week: parseInt(e.target.value)})}
                  >
                    {daysOfWeek.map((day, index) => (
                      <option key={index} value={index}>{day}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label>Start Time</label>
                  <input
                    type="time"
                    value={availabilityForm.start_time}
                    onChange={(e) => setAvailabilityForm({...availabilityForm, start_time: e.target.value})}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>End Time</label>
                  <input
                    type="time"
                    value={availabilityForm.end_time}
                    onChange={(e) => setAvailabilityForm({...availabilityForm, end_time: e.target.value})}
                    required
                  />
                </div>
                <div className="form-group">
                  <button type="submit" className="btn-small">Add</button>
                </div>
              </div>
            </form>

            <div className="availability-list">
              <h4>Current Availability</h4>
              {availability.length === 0 ? (
                <p>No availability set. Add time slots above.</p>
              ) : (
                <table className="availability-table">
                  <thead>
                    <tr>
                      <th>Day</th>
                      <th>Time</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {availability
                      .sort((a, b) => a.day_of_week - b.day_of_week || a.start_time.localeCompare(b.start_time))
                      .map(slot => (
                        <tr key={slot.id}>
                          <td>{daysOfWeek[slot.day_of_week]}</td>
                          <td>{slot.start_time} - {slot.end_time}</td>
                          <td>
                            <button
                              onClick={() => handleDeleteAvailability(slot.id)}
                              className="btn-small warning"
                            >
                              Delete
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Stylists;
